(function() {
  'use strict';

  angular.module('eclipseApp.linkAccount').controller('linkAccountCtrl', LinkAccountCtrl);

  LinkAccountCtrl.$inject = [
    '$rootScope',
    '$modal',
    'linkAccountService',
    '$state',
    '$filter',
    '$window',
    '$timeout',
    'uteLocale',
    'dtmService',
    'dtmServiceConstants',
    '$translate',
    'vcRecaptchaService',
    'env'
  ];

  function LinkAccountCtrl(
    $rootScope,
    $modal,
    linkAccountService,
    $state,
    $filter,
    $window,
    $timeout,
    uteLocale,
    dtmService,
    dtmServiceConstants,
    $translate,
    vcRecaptchaService,
    env
  ) {
    var ctrl = this;
    var dtmRule;

    init();

    function init() {
      dtmRule = dtmServiceConstants.dtmRules.dtmLinkAccount;
      ctrl.whereFindBanToggle = false;
      ctrl.selectedOption = null;
      ctrl.linkAccount = {};
      ctrl.showSuccessMessage = false;
      ctrl.isConnecting = false;
      ctrl.isSendingPrepaid = false;
      ctrl.isConnectingFailed = false;
      ctrl.isSendingPrepaidFailed = false;
      ctrl.isSentPrepaid = false;
      ctrl.linkAccountPrepaid = {};
      ctrl.errorRequiredCounter = 0;
      ctrl.errorMinLengthCounter = 0;
      ctrl.errorRequiredPostalCodeCounter = 0;
      ctrl.errorPatternPostalCodeCounter = 0;
      ctrl.errorRequiredPhoneNoCounter = 0;
      ctrl.errorPatternPhoneNoCounter = 0;

      ctrl.lang = uteLocale.language.toLowerCase();

      if (!$rootScope.userInfo.uuid && !$rootScope.userInfo.userID) {
        //TODO: try to get rid of userInfo on $rootScope!
        try {
          var userJanrainData = JSON.parse(window.localStorage.getItem('easyLoginDataJanrain'));
          $rootScope.userInfo.uuid = userJanrainData.uuid;
          $rootScope.userInfo.userID = userJanrainData.userID;
        } catch (err) {
          console.log('error in parsing easyLoginDataJanrain obj');
        }
      }
      ctrl.recaptchaSiteKeyV2 = env.prepaidLinkAccountRecaptchaSiteKeyV2;
      console.log('Testing::: sitekey', ctrl.recaptchaSiteKeyV2);
    }

    ctrl.validateRecaptchaPrepaid = function(form) {
      form.$submitted = true;
      if (form.phoneNo.$valid) {
        ctrl.resetRecaptchaResponse();
        form.$invalid = false;
        return vcRecaptchaService.execute();
      }
    };

    /* Link Account Owner form submit here */
    ctrl.linkFormSubmit = function(linkAccountFormName) {
      ctrl.formError = '';
      if (linkAccountFormName.$valid) {
        var linkAccountNumber = $filter('accountNumberFilter')(ctrl.linkAccount.accountNumber2.toString());
        ctrl.errorRequiredCounter = 0;
        ctrl.errorMinLengthCounter = 0;
        ctrl.errorRequiredPostalCodeCounter = 0;
        ctrl.errorPatternPostalCodeCounter = 0;
        ctrl.isConnecting = true;
        ctrl.isConnectingFailed = false;
        ctrl.formError = false;

        linkAccountService
          .linkAccountOwner(
            $rootScope.userInfo.uuid,
            $rootScope.userInfo.userID,
            linkAccountNumber,
            ctrl.linkAccount.postalCode
          )
          .then(function(result) {
            if (result.data.error || result.data.status === 'Failed') {
              ctrl.isConnectingFailed = true;
              ctrl.formError = result.data.error;
              if (result.data && result.data.error === '1906') {
                ctrl.formError = null;
                linkAccountService.openAlreadyConnectedModal(result.data.description);
              }
            } else {
              linkAccountService.processUserInfo(result.data.getCustomerAccounts);
              ctrl.showSuccessMessage = true;
            }
          })
          .catch(function() {
            ctrl.formError = '50000';
          })
          .finally(function() {
            ctrl.isConnecting = false;
            $timeout(function() {
              // DC-263 fix: Move the screen up if the there is an error on the top so it is visible to the user
              $window.scrollTo(0, angular.element('div.link-account-error-container')[0].offsetTop);
            }, 100);
          });
      } else {
        fireClientDtmException(linkAccountFormName);
      }
    };

    /* Send verification code to user phone */
    ctrl.sendVerificationCode = function(formName, captchaKey) {
      ctrl.formError = '';
      if (formName.$valid) {
        ctrl.errorRequiredPhoneNoCounter = 0;
        ctrl.errorPatternPhoneNoCounter = 0;
        var phoneNo = ctrl.linkAccountPrepaid.phoneNo.toString();
        ctrl.isSendingPrepaid = true;
        ctrl.isSendingPrepaidFailed = false;
        ctrl.isSentPrepaid = false;
        linkAccountService
          .linkAccountPrepaidSubscriber(
            $rootScope.userInfo.uuid || window.sessionStorage.getItem('guid'),
            phoneNo,
            captchaKey
          )
          .then(function(result) {
            if (result.data.error || result.data.status === 'Failed') {
              ctrl.isSendingPrepaidFailed = true;
              ctrl.formError = result.data.error;
            } else {
              ctrl.isSentPrepaid = true;
              openVerificationModal(phoneNo);
            }
          })
          .catch(function() {
            ctrl.formError = '50000';
          })
          .finally(function() {
            ctrl.isSendingPrepaid = false;
            $timeout(function() {
              // DC-263 fix: Move the screen up if the there is an error on the top so it is visible to the user
              $window.scrollTo(0, angular.element('div.link-account-error-container')[0].offsetTop);
            }, 100);
          });
      } else {
        fireClientDtmException(formName);
      }
    };

    ctrl.verifyReCaptchaCallback = function(resp, formName) {
      ctrl.sendVerificationCode(formName, resp);
    };

    ctrl.resetRecaptchaResponse = function() {
      ctrl.linkAccountPrepaid.recaptcha = '';
      return vcRecaptchaService.reload();
    };

    ctrl.goToMyAccount = function() {
      $state.go('myAccount.overview');
    };

    ctrl.onAccountNumberBlur = function(field) {
      ctrl.accountNumberHasFocus = false;
      if (field.$invalid) {
        if (field.$error.required) {
          ctrl.errorRequiredCounter++;
        }
        if (field.$error.minlength) {
          ctrl.errorMinLengthCounter++;
        }
      }
    };

    ctrl.onPostalCodeBlur = function(field) {
      ctrl.postalCodeHasFocus = false;
      if (field.$invalid) {
        if (field.$error.required) {
          ctrl.errorRequiredPostalCodeCounter++;
        }
        if (field.$error.pattern) {
          ctrl.errorPatternPostalCodeCounter++;
        }
      }
    };

    ctrl.onPhoneNoBlur = function(field) {
      ctrl.phoneNoHasFocus = false;
      if (field.$invalid) {
        if (field.$error.required) {
          ctrl.errorRequiredPhoneNoCounter++;
        }
        if (field.$error.pattern) {
          ctrl.errorPatternPhoneNoCounter++;
        }
      }
    };

    function openVerificationModal(phoneNo) {
      $modal
        .open({
          templateUrl: 'modules/link-account/verify-number/verify-number.view.html',
          controller: 'verifyNumberController',
          controllerAs: 'ctrl',
          windowClass: 'verify-mobile-number-modal',
          size: 'md',
          backdrop: false,
          resolve: {
            modalConfig: function() {
              return {
                phoneNo: phoneNo
              };
            }
          }
        })
        .result.then(function(result) {
          ctrl.showSuccessMessage = result;
        });
    }

    function fireClientDtmException(linkAccountFormName) {
      var errorKeys = [];
      if (ctrl.selectedOption === 'linkHasAccount') {
        if (
          linkAccountFormName &&
          ((linkAccountFormName.accountNumber2 && linkAccountFormName.accountNumber2.$error.required) ||
            (linkAccountFormName.postalCode && linkAccountFormName.postalCode.$error.required))
        ) {
          errorKeys.push('global.error.inline.field.required');
        }
        if (
          linkAccountFormName &&
          linkAccountFormName.postalCode &&
          !linkAccountFormName.postalCode.$error.required &&
          linkAccountFormName.postalCode.$error.pattern
        ) {
          errorKeys.push('global.error.inline.postalCode.invalid');
        }
      } else if (ctrl.selectedOption === 'linkPrepaidCustomer') {
        if (ctrl.linkAccountPrepaid && ctrl.linkAccountPrepaid.phoneNo == null) {
          errorKeys.push('global.error.inline.phone.requiredImpersonal');
        }
      }

      if (errorKeys.length > 0) {
        $translate(errorKeys).then(function(translatedValues) {
          var values = [];
          angular.forEach(errorKeys, function(value) {
            values.push(translatedValues[value]);
          });
          var clientSideError = 'CS|' + values;
          dtmService.setVar(dtmRule.eVar, clientSideError);
          dtmService.direct(dtmRule.errorRule);
        });
      }
    }
  }
})();
